import React from 'react'
import {TransitionGroup, CSSTransition} from 'react-transition-group'

export const NotesMetal = ({notes, onRemove}) => (
  <form action="">
  <table class="table table-striped">
  <thead>
    <tr>
      <th scope="col">Метал</th>
      <th scope="col">Удалить</th>
    </tr>
  </thead>
 
      <tbody>
      {notes.map(note => (
        <tr>
          <td>{note.title}</td>
    
         <td> <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            onClick={() => onRemove(note.id)}
          >
            &times;
          </button></td>
        </tr>
        
        ))}
      </tbody>
    </table>
    
  </form>
)
